// Passive GPS-trust chip — indicates whether a single-player response was
// backed by ≥ 7 days of GPS records. Moved verbatim from DecisionEnginePage.js
// during Phase 2 of the System Consolidation.
//
// Render nothing outside single-player contexts (caller guards).
import React from 'react';
import { Satellite } from 'lucide-react';

export const GpsChip = ({ available }) => {
  const isOn = !!available;
  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-medium ${
        isOn
          ? 'bg-emerald-50 border-emerald-200 text-emerald-700 dark:bg-emerald-950/30 dark:border-emerald-900/50 dark:text-emerald-400'
          : 'bg-gray-50 border-gray-200 text-gray-500 dark:bg-gray-900/40 dark:border-gray-800'
      }`}
      data-testid="gps-chip"
      data-gps-available={isOn ? 'true' : 'false'}
      title={isOn ? 'GPS-informed (≥ 7 days of records)' : 'No recent GPS data — fallback context only'}
    >
      <Satellite className="h-3 w-3" />
      <span>GPS</span>
      <span
        className={`inline-block w-1.5 h-1.5 rounded-full ${isOn ? 'bg-emerald-500' : 'bg-gray-400'}`}
      />
    </div>
  );
};
